import React from 'react';

const s = {
  page: {
    minHeight: '100vh',
    background: '#0f0f12',
    color: '#fff',
    fontFamily: "-apple-system, BlinkMacSystemFont, 'SF Pro Text', system-ui, sans-serif",
    padding: '0 0 60px',
  },
  header: {
    background: 'rgba(15,15,18,.9)',
    backdropFilter: 'blur(16px)',
    borderBottom: '1px solid rgba(255,255,255,.08)',
    padding: '16px 24px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    position: 'sticky',
    top: 0,
    zIndex: 50,
  },
  logo: {
    fontSize: 20,
    fontWeight: 900,
    letterSpacing: 1,
    color: '#fff',
    WebkitTextStroke: '1.5px #00ff99',
    textShadow: '0 0 10px rgba(0,255,136,.4)',
    textDecoration: 'none',
  },
  backBtn: {
    display: 'flex',
    alignItems: 'center',
    gap: 6,
    color: 'rgba(255,255,255,.5)',
    textDecoration: 'none',
    fontSize: 14,
    fontWeight: 600,
    padding: '8px 14px',
    borderRadius: 10,
    border: '1px solid rgba(255,255,255,.1)',
    background: 'rgba(255,255,255,.04)',
    transition: 'all .15s',
  },
  wrap: {
    maxWidth: 720,
    margin: '0 auto',
    padding: '40px 24px',
  },
  badge: {
    display: 'inline-block',
    background: 'linear-gradient(135deg,#00ff99,#00e5ff)',
    color: '#000',
    fontSize: 11,
    fontWeight: 800,
    padding: '4px 12px',
    borderRadius: 20,
    letterSpacing: .5,
    textTransform: 'uppercase',
    marginBottom: 16,
  },
  title: {
    fontSize: 32,
    fontWeight: 900,
    color: '#fff',
    margin: '0 0 8px',
    lineHeight: 1.1,
  },
  meta: {
    fontSize: 13,
    color: 'rgba(255,255,255,.4)',
    margin: '0 0 40px',
    fontWeight: 500,
  },
  divider: {
    height: 1,
    background: 'rgba(255,255,255,.07)',
    margin: '32px 0',
  },
  section: {
    marginBottom: 36,
  },
  sectionNum: {
    fontSize: 11,
    fontWeight: 800,
    textTransform: 'uppercase',
    letterSpacing: 1,
    color: '#00ff99',
    marginBottom: 6,
  },
  h2: {
    fontSize: 18,
    fontWeight: 800,
    color: '#fff',
    margin: '0 0 12px',
  },
  p: {
    fontSize: 15,
    lineHeight: 1.75,
    color: 'rgba(255,255,255,.75)',
    margin: '0 0 12px',
  },
  ul: {
    margin: '8px 0 12px 20px',
    display: 'flex',
    flexDirection: 'column',
    gap: 8,
  },
  li: {
    fontSize: 15,
    lineHeight: 1.65,
    color: 'rgba(255,255,255,.75)',
  },
  highlight: {
    background: 'rgba(0,255,136,.06)',
    border: '1px solid rgba(0,255,136,.15)',
    borderRadius: 12,
    padding: '16px 20px',
    marginBottom: 12,
  },
  contactCard: {
    background: 'rgba(255,255,255,.04)',
    border: '1px solid rgba(255,255,255,.09)',
    borderRadius: 16,
    padding: '24px',
    marginTop: 8,
  },
  contactEmail: {
    color: '#00ff99',
    textDecoration: 'none',
    fontWeight: 700,
    fontSize: 15,
  },
  footer: {
    marginTop: 48,
    paddingTop: 24,
    borderTop: '1px solid rgba(255,255,255,.07)',
    display: 'flex',
    flexWrap: 'wrap',
    gap: 16,
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  footerLinks: {
    display: 'flex',
    gap: 20,
    flexWrap: 'wrap',
  },
  footerLink: {
    color: 'rgba(255,255,255,.4)',
    textDecoration: 'none',
    fontSize: 13,
    fontWeight: 600,
  },
  footerText: {
    color: 'rgba(255,255,255,.25)',
    fontSize: 12,
  },
};

export default function TermsOfService() {
  return (
    <div style={s.page}>
      {/* ── Header ── */}
      <header style={s.header}>
        <a href="https://app.tracksyhq.com" style={s.logo}>TRACKSY</a>
        <a href="https://app.tracksyhq.com" style={s.backBtn}>← Back to App</a>
      </header>

      <div style={s.wrap}>
        <div style={s.badge}>Legal</div>
        <h1 style={s.title}>Terms of Service</h1>
        <p style={s.meta}>Last updated: March 17, 2026 &nbsp;·&nbsp; Effective date: March 17, 2026</p>

        <div style={s.highlight}>
          <p style={{ ...s.p, margin: 0, color: 'rgba(255,255,255,.85)' }}>
            Please read these Terms of Service carefully before using Tracksy. By creating an account
            or using any part of the service, you agree to be bound by these terms.
          </p>
        </div>

        <div style={s.divider} />

        {/* 1. Acceptance */}
        <div style={s.section}>
          <div style={s.sectionNum}>Section 1</div>
          <h2 style={s.h2}>Acceptance of Terms</h2>
          <p style={s.p}>
            These Terms of Service ("Terms") constitute a legally binding agreement between you
            ("User," "you," or "your") and Tracksy, a sole proprietorship owned and operated by Bear,
            located in Frisco, Texas ("Tracksy," "we," "us," or "our").
          </p>
          <p style={s.p}>
            By accessing or using the Tracksy application at app.tracksyhq.com, creating an account,
            or otherwise interacting with our service, you confirm that you have read, understood, and
            agree to these Terms. If you do not agree, do not use Tracksy.
          </p>
          <p style={s.p}>
            You must be at least 18 years of age to use this service. By using Tracksy, you represent
            that you meet this age requirement.
          </p>
        </div>

        <div style={s.divider} />

        {/* 2. Description of Service */}
        <div style={s.section}>
          <div style={s.sectionNum}>Section 2</div>
          <h2 style={s.h2}>Description of Service</h2>
          <p style={s.p}>
            Tracksy is a software-as-a-service (SaaS) application designed for automotive
            salespeople to track daily sales activity, monitor commissions, manage leads, and
            measure performance against personal goals.
          </p>
          <p style={s.p}>Core features include:</p>
          <ul style={s.ul}>
            <li style={s.li}>Sales activity logging and performance tracking</li>
            <li style={s.li}>Commission and gross profit calculation with split and combined modes</li>
            <li style={s.li}>Lead and appointment management</li>
            <li style={s.li}>Voice memo recording and cloud storage</li>
            <li style={s.li}>AI-assisted sales coaching via an in-app chatbot</li>
            <li style={s.li}>Goal setting and progress visualization</li>
          </ul>
          <p style={s.p}>
            Tracksy is available as a web application via any modern browser and as a Progressive
            Web App (PWA) that can be installed on mobile and desktop devices. We reserve the right
            to modify, add, or remove features at any time.
          </p>
        </div>

        <div style={s.divider} />

        {/* 3. User Accounts */}
        <div style={s.section}>
          <div style={s.sectionNum}>Section 3</div>
          <h2 style={s.h2}>User Accounts</h2>
          <p style={s.p}>
            To access Tracksy, you must create an account using a valid email address. You may
            sign in with any email-based account or via Google Sign-In through Firebase Authentication.
            By creating an account, you authorize Tracksy to store and use your email address and
            name solely for the purpose of creating and managing your account.
          </p>
          <p style={s.p}>
            You are permitted one account per person. Creating multiple accounts to circumvent
            subscription requirements or billing is prohibited and may result in account termination.
          </p>
          <p style={s.p}>
            You are responsible for maintaining the security of your account credentials. Notify us
            immediately at tracksysales@gmail.com if you suspect unauthorized access to your account.
            We are not liable for any loss resulting from unauthorized use of your account caused by
            your failure to keep your credentials secure.
          </p>
        </div>

        <div style={s.divider} />

        {/* 4. Subscription and Billing */}
        <div style={s.section}>
          <div style={s.sectionNum}>Section 4</div>
          <h2 style={s.h2}>Subscription and Billing</h2>
          <p style={s.p}>
            Access to Tracksy requires a paid monthly subscription. Subscriptions are processed
            and managed through Stripe, a third-party payment processor. By subscribing, you agree
            to Stripe's Terms of Service in addition to these Terms.
          </p>
          <ul style={s.ul}>
            <li style={s.li}>
              <strong style={{ color: '#fff' }}>Free Trial:</strong> New accounts receive a 7-day
              free trial. No charge is made until the trial period ends. You may cancel during the
              trial without being charged.
            </li>
            <li style={s.li}>
              <strong style={{ color: '#fff' }}>Automatic Renewal:</strong> Your subscription
              automatically renews each month on your billing date. By subscribing, you authorize
              Tracksy to charge your payment method on file each renewal cycle.
            </li>
            <li style={s.li}>
              <strong style={{ color: '#fff' }}>Pricing:</strong> Subscription pricing is displayed
              at the time of signup. We reserve the right to change pricing with at least 30 days
              notice by email to your registered address. Continued use after the notice period
              constitutes acceptance of the new price.
            </li>
            <li style={s.li}>
              <strong style={{ color: '#fff' }}>Refunds:</strong> All subscription fees are
              non-refundable except as required by applicable law. We do not provide prorated
              refunds for partial months. If you cancel, your access continues until the end of
              your current billing period.
            </li>
            <li style={s.li}>
              <strong style={{ color: '#fff' }}>Failed Payments:</strong> If a payment fails, we
              may suspend access to your account until the outstanding balance is resolved.
            </li>
          </ul>
          <p style={s.p}>
            To manage, update, or cancel your subscription, access the billing portal through your
            account settings within the app.
          </p>
        </div>

        <div style={s.divider} />

        {/* 5. Acceptable Use */}
        <div style={s.section}>
          <div style={s.sectionNum}>Section 5</div>
          <h2 style={s.h2}>Acceptable Use</h2>
          <p style={s.p}>You agree to use Tracksy only for lawful purposes. You may not:</p>
          <ul style={s.ul}>
            <li style={s.li}>Reverse engineer, decompile, disassemble, or attempt to derive the source code of any part of Tracksy</li>
            <li style={s.li}>Scrape, crawl, or systematically extract data from the service using automated tools</li>
            <li style={s.li}>Share, sell, or transfer your account credentials to any other person</li>
            <li style={s.li}>Use Tracksy to store, process, or transmit any unlawful, harmful, or objectionable content</li>
            <li style={s.li}>Attempt to gain unauthorized access to any part of the service or its related infrastructure</li>
            <li style={s.li}>Interfere with or disrupt the integrity or performance of the service</li>
            <li style={s.li}>Use the service for any purpose outside of legitimate automotive sales activity tracking</li>
            <li style={s.li}>Impersonate another person or misrepresent your affiliation with any entity</li>
          </ul>
          <p style={s.p}>
            Violation of this section may result in immediate account termination without refund.
          </p>
        </div>

        <div style={s.divider} />

        {/* 6. Data and Privacy */}
        <div style={s.section}>
          <div style={s.sectionNum}>Section 6</div>
          <h2 style={s.h2}>Data and Privacy</h2>
          <p style={s.p}>
            Your privacy matters to us. Our Privacy Policy, available at{' '}
            <a href="/privacy" style={{ color: '#00ff99' }}>app.tracksyhq.com/privacy</a>, describes
            in detail how we collect, use, store, and protect your personal data.
          </p>
          <p style={s.p}>
            By using Tracksy, you acknowledge and consent to the data practices described in the
            Privacy Policy, which is incorporated into these Terms by reference.
          </p>
        </div>

        <div style={s.divider} />

        {/* 7. Intellectual Property */}
        <div style={s.section}>
          <div style={s.sectionNum}>Section 7</div>
          <h2 style={s.h2}>Intellectual Property</h2>
          <p style={s.p}>
            All rights, title, and interest in and to the Tracksy service — including but not
            limited to the application code, design, branding, logos, feature set, and underlying
            technology — are and remain the exclusive property of Tracksy and its owner. Nothing
            in these Terms grants you any ownership interest in the service.
          </p>
          <p style={s.p}>
            You retain full ownership of all data you enter into Tracksy, including sales records,
            activity logs, lead information, voice memos, and commission data ("User Content").
            You grant Tracksy a limited license to store, process, and display your User Content
            solely for the purpose of providing the service to you.
          </p>
          <p style={s.p}>
            We do not claim ownership over your User Content and will not use it for purposes other
            than operating the service.
          </p>
        </div>

        <div style={s.divider} />

        {/* 8. Termination */}
        <div style={s.section}>
          <div style={s.sectionNum}>Section 8</div>
          <h2 style={s.h2}>Termination</h2>
          <p style={s.p}>
            <strong style={{ color: '#fff' }}>By you:</strong> You may cancel your subscription
            and close your account at any time through the billing portal in your account settings.
            Cancellation takes effect at the end of your current billing period. We do not provide
            refunds for unused time.
          </p>
          <p style={s.p}>
            <strong style={{ color: '#fff' }}>By us:</strong> Tracksy reserves the right to
            suspend or terminate your account immediately and without notice if you violate these
            Terms, engage in fraudulent activity, or if we determine your use is harmful to other
            users or the integrity of the service.
          </p>
          <p style={s.p}>
            Upon termination, your right to access the service ends immediately. We may retain
            your data for a reasonable period as required by law or for legitimate business purposes,
            after which it may be permanently deleted.
          </p>
        </div>

        <div style={s.divider} />

        {/* 9. Disclaimer of Warranties */}
        <div style={s.section}>
          <div style={s.sectionNum}>Section 9</div>
          <h2 style={s.h2}>Disclaimer of Warranties</h2>
          <p style={s.p}>
            TRACKSY IS PROVIDED "AS IS" AND "AS AVAILABLE" WITHOUT WARRANTY OF ANY KIND, EXPRESS
            OR IMPLIED. TO THE MAXIMUM EXTENT PERMITTED BY APPLICABLE LAW, TRACKSY EXPRESSLY
            DISCLAIMS ALL WARRANTIES, INCLUDING BUT NOT LIMITED TO IMPLIED WARRANTIES OF
            MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, AND NON-INFRINGEMENT.
          </p>
          <p style={s.p}>
            We do not warrant that the service will be uninterrupted, error-free, or free of
            viruses or other harmful components. We do not warrant the accuracy, completeness,
            or usefulness of any information provided through the service, including commission
            calculations or activity projections.
          </p>
          <p style={s.p}>
            Your use of Tracksy is at your sole risk. Commission projections and activity targets
            generated by the app are estimates only and do not constitute financial or professional advice.
          </p>
        </div>

        <div style={s.divider} />

        {/* 10. Limitation of Liability */}
        <div style={s.section}>
          <div style={s.sectionNum}>Section 10</div>
          <h2 style={s.h2}>Limitation of Liability</h2>
          <p style={s.p}>
            TO THE MAXIMUM EXTENT PERMITTED BY APPLICABLE LAW, IN NO EVENT SHALL TRACKSY OR ITS
            OWNER BE LIABLE FOR ANY INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAL, OR PUNITIVE
            DAMAGES, INCLUDING BUT NOT LIMITED TO LOSS OF PROFITS, LOSS OF DATA, LOSS OF GOODWILL,
            OR BUSINESS INTERRUPTION, ARISING OUT OF OR IN CONNECTION WITH YOUR USE OF OR INABILITY
            TO USE THE SERVICE.
          </p>
          <p style={s.p}>
            IN ALL CASES, TRACKSY'S TOTAL CUMULATIVE LIABILITY ARISING FROM OR RELATED TO THESE
            TERMS OR THE SERVICE SHALL NOT EXCEED THE TOTAL AMOUNTS PAID BY YOU TO TRACKSY IN THE
            THREE (3) MONTHS IMMEDIATELY PRECEDING THE CLAIM.
          </p>
          <p style={s.p}>
            Some jurisdictions do not allow the exclusion or limitation of liability for consequential
            or incidental damages, so the above limitation may not apply to you.
          </p>
        </div>

        <div style={s.divider} />

        {/* 11. Governing Law */}
        <div style={s.section}>
          <div style={s.sectionNum}>Section 11</div>
          <h2 style={s.h2}>Governing Law and Dispute Resolution</h2>
          <p style={s.p}>
            These Terms shall be governed by and construed in accordance with the laws of the
            State of Texas, United States, without regard to its conflict of law provisions.
          </p>
          <p style={s.p}>
            Any disputes arising from or relating to these Terms or the Tracksy service shall
            be subject to the exclusive jurisdiction of the state and federal courts located in
            Collin County, Texas. You consent to the personal jurisdiction of such courts.
          </p>
          <p style={s.p}>
            Before initiating any formal legal proceedings, you agree to attempt to resolve the
            dispute informally by contacting us at tracksysales@gmail.com. We will attempt to
            resolve the dispute within 30 days.
          </p>
        </div>

        <div style={s.divider} />

        {/* 12. Changes to Terms */}
        <div style={s.section}>
          <div style={s.sectionNum}>Section 12</div>
          <h2 style={s.h2}>Changes to These Terms</h2>
          <p style={s.p}>
            We reserve the right to modify these Terms at any time. For material changes, we
            will provide at least 30 days notice by email to the address associated with your
            account before the changes take effect.
          </p>
          <p style={s.p}>
            Non-material changes (such as clarifications, corrections, or additions that do not
            materially affect your rights or obligations) may be made without prior notice.
            The "Last updated" date at the top of this page reflects the most recent revision.
          </p>
          <p style={s.p}>
            Continued use of the service after the effective date of any updated Terms constitutes
            your acceptance of the new Terms. If you do not agree to the revised Terms, you must
            stop using the service and cancel your subscription.
          </p>
        </div>

        <div style={s.divider} />

        {/* 13. Contact */}
        <div style={s.section}>
          <div style={s.sectionNum}>Section 13</div>
          <h2 style={s.h2}>Contact Information</h2>
          <p style={s.p}>
            If you have any questions about these Terms, or need to reach us for any reason,
            please contact us using the information below.
          </p>
          <div style={s.contactCard}>
            <p style={{ ...s.p, margin: '0 0 4px', color: 'rgba(255,255,255,.5)', fontSize: 12, fontWeight: 700, textTransform: 'uppercase', letterSpacing: .8 }}>Tracksy</p>
            <p style={{ ...s.p, margin: '0 0 4px' }}>Frisco, Texas, United States</p>
            <a href="mailto:tracksysales@gmail.com" style={s.contactEmail}>tracksysales@gmail.com</a>
          </div>
        </div>

        {/* Footer */}
        <div style={s.footer}>
          <div style={s.footerLinks}>
            <a href="/privacy" style={s.footerLink}>Privacy Policy</a>
            <a href="/support" style={s.footerLink}>Support</a>
            <a href="https://app.tracksyhq.com" style={s.footerLink}>Back to App</a>
          </div>
          <span style={s.footerText}>© 2026 Tracksy. All rights reserved.</span>
        </div>
      </div>
    </div>
  );
}
